import React from "react";
import { IPhotoUploaderProps } from "./PhotoUploader.props";

import styles from "./PhotoUploader.module.scss";

export default function PhotoUploader(props: IPhotoUploaderProps) {
  return <div className={styles.wrapper}>PhotoUploader</div>;
}
